import { TimeFrameTypes } from "@app/models/enums";
import { AdminReportSummaryDto } from "./admin-dashboard-summary";
import { ReportingItemsFilterDto } from "./dashboard-activities";

export interface AccountDashboardSummaryPostDto {
  startDate?: string;
  endDate?: string;
  period: TimeFrameTypes;
  timeZoneOffset?: number;
  locations?: ReportingItemsFilterDto;
}

/**
 * Single pre-aggregated response for the dashboard total-widgets row.
 * Each section carries `{ total, summary: [{ totalCount, name }] }`.
 * The backend returns extra sections (topLocationActivities, locationActivities)
 * that the total-widgets row does not consume.
 */
export interface AccountDashboardSummaryDto {
  engagements: AdminReportSummaryDto;
  kpiActivities: AdminReportSummaryDto;
  customLinks: AdminReportSummaryDto;
  appsActivities: AdminReportSummaryDto;
  terminalActivities: AdminReportSummaryDto;
  engagementAttempts?: AdminReportSummaryDto | null;
}
